import { CircularProgress, ListItemText, Stack, Tooltip } from "@mui/material";
import { GroupingOptionIcon } from "../../GroupingOptionIcon";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import {
  PossibleFilterValue,
  PossibleFilterValues,
} from "@/services/cloudchipr.api";
import { DropdownSelectOption } from "@/components/common/select/dropdown-select/utils/types/types";

export const getDimensionGroupingOptions = (
  dimensionsGroupingValues: PossibleFilterValues,
  value: "category" | "category_v2",
): DropdownSelectOption => {
  return {
    value: value,
    disableSelection: true,
    label: (
      <Stack direction="row" spacing={1} alignItems="center">
        <GroupingOptionIcon grouping={value} />
        <ListItemText primary="Dimensions" />
      </Stack>
    ),
    rawValue: { search: "dimensions category" },
    nestedOptions: dimensionsGroupingValues.map((option) => ({
      value: option.value,
      rawValue: { search: `${option.title} category dimension` },
      label: getDimensionGroupingOptionLabel(option, value),
    })),
  };
};

const getDimensionGroupingOptionLabel = (
  option: PossibleFilterValue,
  value: "category" | "category_v2",
) => {
  const mainOption = (
    <Stack direction="row" spacing={1} alignItems="center" pl={4} pr={2}>
      <GroupingOptionIcon grouping={value} />
      <TypographyWithTooltip
        variant="body2"
        title={option.title ?? option.value}
      />
    </Stack>
  );

  if (option.dimension_status === "in_progress") {
    return (
      <Tooltip
        arrow
        placement="right"
        title="This Dimension is still being processed. Cost will appear for each category once processing is complete."
      >
        <Stack direction="row" justifyContent="space-between" pr={2}>
          {mainOption}

          <CircularProgress size={16} color="inherit" />
        </Stack>
      </Tooltip>
    );
  }

  return mainOption;
};
